export class RpcMpProviderSuccessResponse<T> {
  public status: boolean;

  public data: T;

  public unwrapOrThrow(): T {
    return this.data;
  }

  public throwIfFailed(): RpcMpProviderSuccessResponse<T> {
    return this;
  }
}
